const getNestedProperty = (obj, path, defaultValue) => {
  if (!obj || !path) {
    return defaultValue || void 0;
  }
  const pathArray = path.split(".");
  const result = pathArray.reduce((obj2, prop) => {
    return obj2 && obj2[prop] ? obj2[prop] : null;
  }, obj);
  return result || defaultValue || void 0;
};
export {
  getNestedProperty
};
//# sourceMappingURL=get-nested-property.js.map
